import React from "react";
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaTimesCircle,
  FaExclamationCircle,
  FaInfoCircle
} from "react-icons/fa";


const fascePunteggio = [
  {
    min: 80,
    max: 100,
    descrizione: "Conforme o quasi → Mantenere e monitorare",
    Icon: FaCheckCircle,
    livello: "BASSO",
    alias: ["LOW", "MINIMO"],
    badgeStyle: "bg-gray-200 text-green-700"
  },
  {
    min: 60,
    max: 79,
    descrizione: "Parzialmente conforme → Prioritizzare i gap critici",
    Icon: FaExclamationTriangle,
    livello: "MEDIO",
    alias: ["MIDDLE", "INTERMEDIO"],
    badgeStyle: "bg-gray-200 text-yellow-700"
  },
  {
    min: 40,
    max: 59,
    descrizione: "Rischio medio-alto → Interventi urgenti",
    Icon: FaTimesCircle,
    livello: "ALTO",
    alias: ["HIGH", "ELEVATED"],
    badgeStyle: "bg-gray-200 text-orange-700"
  },
  {
    min: 0,
    max: 39,
    descrizione:
      "Alta esposizione → Revisione urgente della postura di sicurezza",
    Icon: FaExclamationCircle,
    livello: "ELEVATO",
    alias: ["CRITICAL", "VERY_HIGH"],
    badgeStyle: "bg-gray-200 text-red-700"
  },
  {
    min: 101,
    max: 200,
    descrizione: "Solo informativo → Nessuna azione richiesta",
    Icon: FaInfoCircle,
    livello: "INFO",
    alias: ["INFORMAZIONE", "DETAILS"],
    badgeStyle: "bg-gray-200 text-gray-500"
  }
];

// 2) Costruisco la mappa per lookup O(1) su livello o alias
const badgeByLevel = fascePunteggio.reduce((map, item) => {
  const keys = [item.livello, ...(item.alias || [])];
  keys.forEach((key) => {
    map[key.trim().toUpperCase()] = item;
  });
  return map;
}, {});

const CriticalityBadge = React.memo(function ({
  punteggio,
  livello
}) {


  let fascia;

  if (typeof livello === "string") {
    const key = livello.trim().toUpperCase();
    fascia = badgeByLevel[key];
  } else if (typeof punteggio === "number") {
    fascia = fascePunteggio.find((item) => punteggio >= item.min && punteggio <= item.max);
  }

  // Se non trova nulla, mostro fallback
  if (!fascia) {
    return (
      <span className="px-2 py-1 rounded bg-gray-200 text-gray-800">
        N/A
      </span>
    );
  }

  const { Icon, livello: lvl, badgeStyle } = fascia;

  return (
    <div className="flex items-center space-x-2">
      <span className={`px-2 py-1 rounded border-[2px] border-gray-400 w-28 justify-center font-semibold flex items-center space-x-2  ${badgeStyle} `}>
        <Icon />
        <span>{lvl}</span>
      </span>
    </div>
  );
});

export default CriticalityBadge;
